import React from "react";

export default function Title() {
  return (
    <>
      <h2>Get a Quote for specific parts</h2>
      <p className="sub-title">
        Fill out the form below with the details of the specific parts you need.
        We will get back to you with the best prices.{" "}
        <em>Fields marked with * are mandatory.</em>
      </p>
    </>
  );
}
